import styled from 'styled-components';

import { BorderedButtonContainer } from '@web/timesheets/CreateTimesheetModal/components/buttons/buttons.styles';

export const TimePickersRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 10px;

  input {
    width: 100%;
  }

  ${BorderedButtonContainer} {
    display: none;
  }

  [role='combobox'][aria-expanded='true']
    ~ ${BorderedButtonContainer},
    &:hover
    ${BorderedButtonContainer} {
    display: flex;
  }
`;
